import { CatalogSource, SupportedCatalogSourceType } from './catalog-source';

export default class OracleCatalogSource extends CatalogSource {
	getType() {
		return SupportedCatalogSourceType.Oracle;
	}
	getTypeOptionGroupName() {
		return 'Oracle OptionGroup';
	}
}
